import React from 'react';

import { Logo } from '../../shared';

import './styles.scss';

export const SetupHeader = () => (
  <div className='setupheader'>
    <Logo />
  </div>
);

export default SetupHeader;



// WEBPACK FOOTER //
// ./src/components/setup/SetupHeader/index.jsx